import { Navigate, useLocation } from 'react-router-dom';

import type { WizardStep } from './types';

/**
 * Legacy-route shim: `/onboarding/survey` and `/onboarding/review` mount
 * this to bounce into the unified wizard, preserving any existing query
 * params (e.g. `?draftId=`) so bookmarked/emailed links keep working.
 */
export const OnboardingWizardRedirect = ({ step }: { step: WizardStep }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set('step', step);
  return (
    <Navigate
      to={{ pathname: '/onboarding/wizard', search: `?${params.toString()}` }}
      replace
    />
  );
};
